/**
 * Maps CGIAR country names to ISO 3166-1 alpha-3 codes
 * for use with react-simple-maps world atlas data.
 */

const COUNTRY_TO_ISO3 = {
  'Kenya': 'KEN',
  'Ethiopia': 'ETH',
  'India': 'IND',
  'Bangladesh': 'BGD',
  'Nigeria': 'NGA',
  'Brazil': 'BRA',
  'Colombia': 'COL',
  'Peru': 'PER',
  'Tanzania': 'TZA',
  'United Republic of Tanzania': 'TZA',
  'Uganda': 'UGA',
  'Rwanda': 'RWA',
  'Ghana': 'GHA',
  'Senegal': 'SEN',
  'Mali': 'MLI',
  'Burkina Faso': 'BFA',
  'Niger': 'NER',
  'Cameroon': 'CMR',
  'Philippines': 'PHL',
  'Vietnam': 'VNM',
  'Viet Nam': 'VNM',
  'Myanmar': 'MMR',
  'Cambodia': 'KHM',
  'Nepal': 'NPL',
  'Pakistan': 'PAK',
  'Afghanistan': 'AFG',
  'Mozambique': 'MOZ',
  'Malawi': 'MWI',
  'Zambia': 'ZMB',
  'Zimbabwe': 'ZWE',
  'South Africa': 'ZAF',
  'Egypt': 'EGY',
  'Morocco': 'MAR',
  'Tunisia': 'TUN',
  'China': 'CHN',
  'Indonesia': 'IDN',
  'Thailand': 'THA',
  'Madagascar': 'MDG',
  'Democratic Republic of the Congo': 'COD',
  "Cote d'Ivoire": 'CIV',
  "Côte d'Ivoire": 'CIV',
  'Lao PDR': 'LAO',
  "Lao People's Democratic Republic": 'LAO',
  'Laos': 'LAO',
  'Sri Lanka': 'LKA',
  'Mexico': 'MEX',
  'Guatemala': 'GTM',
  'Honduras': 'HND',
  'Haiti': 'HTI',
  'Bolivia': 'BOL',
  'Ecuador': 'ECU',
  'Sudan': 'SDN',
  'South Sudan': 'SSD',
  'Yemen': 'YEM',
  'Jordan': 'JOR',
  'Lebanon': 'LBN',
  'Iraq': 'IRQ',
  'Tajikistan': 'TJK',
  'Uzbekistan': 'UZB',
  'Kyrgyzstan': 'KGZ',
  'Mongolia': 'MNG',
  // Additional countries and common variations
  'Angola': 'AGO',
  'Argentina': 'ARG',
  'Benin': 'BEN',
  'Burundi': 'BDI',
  'Chad': 'TCD',
  'Chile': 'CHL',
  'Congo': 'COG',
  'Republic of the Congo': 'COG',
  'Costa Rica': 'CRI',
  'Cuba': 'CUB',
  'Dominican Republic': 'DOM',
  'El Salvador': 'SLV',
  'Eritrea': 'ERI',
  'Eswatini': 'SWZ',
  'Swaziland': 'SWZ',
  'Fiji': 'FJI',
  'Gabon': 'GAB',
  'Gambia': 'GMB',
  'The Gambia': 'GMB',
  'Guinea': 'GIN',
  'Guinea-Bissau': 'GNB',
  'Guyana': 'GUY',
  'Iran': 'IRN',
  'Jamaica': 'JAM',
  'Lesotho': 'LSO',
  'Liberia': 'LBR',
  'Libya': 'LBY',
  'Namibia': 'NAM',
  'Nicaragua': 'NIC',
  'Panama': 'PAN',
  'Papua New Guinea': 'PNG',
  'Paraguay': 'PRY',
  'Sierra Leone': 'SLE',
  'Solomon Islands': 'SLB',
  'Somalia': 'SOM',
  'Suriname': 'SUR',
  'Syria': 'SYR',
  'Syrian Arab Republic': 'SYR',
  'Timor-Leste': 'TLS',
  'East Timor': 'TLS',
  'Togo': 'TGO',
  'Trinidad and Tobago': 'TTO',
  'Uruguay': 'URY',
  'Venezuela': 'VEN',
  // Additional countries found in CGIAR data
  'Botswana': 'BWA',
  'Germany': 'DEU',
  'Malaysia': 'MYS',
  'United States of America': 'USA',
  'Austria': 'AUT',
  'Comoros': 'COM',
  'Kazakhstan': 'KAZ',
  'Algeria': 'DZA',
  'Bhutan': 'BTN',
  'Djibouti': 'DJI',
  'Singapore': 'SGP',
  'Central African Republic': 'CAF',
  'Sao Tome and Principe': 'STP',
  'Mauritius': 'MUS',
  'Seychelles': 'SYC',
  'Mauritania': 'MRT',
  'Kuwait': 'KWT',
  'France': 'FRA',
  'Latvia': 'LVA',
  'Poland': 'POL',
  'Vanuatu': 'VUT',
  'Australia': 'AUS',
  'Spain': 'ESP',
  'Italy': 'ITA',
  'Sweden': 'SWE',
  'Finland': 'FIN',
  'Belgium': 'BEL',
  'Belize': 'BLZ',
  'Brunei Darussalam': 'BRN',
  'Bulgaria': 'BGR',
  'Canada': 'CAN',
  'Croatia': 'HRV',
  'Denmark': 'DNK',
  'Equatorial Guinea': 'GNQ',
  'Estonia': 'EST',
  'Georgia': 'GEO',
  'Greece': 'GRC',
  'Hungary': 'HUN',
  'Ireland': 'IRL',
  'Japan': 'JPN',
  'Lithuania': 'LTU',
  'Malta': 'MLT',
  'New Zealand': 'NZL',
  'Norway': 'NOR',
  'Oman': 'OMN',
  'Portugal': 'PRT',
  'Qatar': 'QAT',
  'Romania': 'ROU',
  'Samoa': 'WSM',
  'Saudi Arabia': 'SAU',
  'Serbia': 'SRB',
  'Slovakia': 'SVK',
  'Slovenia': 'SVN',
  'Switzerland': 'CHE',
  'Ukraine': 'UKR',
  'Bahrain': 'BHR',
  'Azerbaijan': 'AZE',
  'Turkmenistan': 'TKM',
  'Taiwan': 'TWN',
  'Russian Federation': 'RUS',
  'Bosnia and Herzegovina': 'BIH',
  // UN Developing economies — additional countries/territories
  'Armenia': 'ARM',
  'Antigua and Barbuda': 'ATG',
  'Bahamas': 'BHS',
  'Barbados': 'BRB',
  'Dominica': 'DMA',
  'Grenada': 'GRD',
  'Kiribati': 'KIR',
  'Maldives': 'MDV',
  'Marshall Islands': 'MHL',
  'Nauru': 'NRU',
  'Palau': 'PLW',
  'Saint Kitts and Nevis': 'KNA',
  'Saint Lucia': 'LCA',
  'Saint Vincent and the Grenadines': 'VCT',
  'Tuvalu': 'TUV',
  'Tonga': 'TON',
  'United Arab Emirates': 'ARE',
  'Hong Kong': 'HKG',
  'Aruba': 'ABW',
  'Curaçao': 'CUW',
  'Puerto Rico': 'PRI',
  'Guam': 'GUM',
  'New Caledonia': 'NCL',
  'French Polynesia': 'PYF',
  'French Guiana': 'GUF',
  'Guadeloupe': 'GLP',
  'Martinique': 'MTQ',
  'Réunion': 'REU',
  'Mayotte': 'MYT',
  'Western Sahara': 'ESH',
  'Montserrat': 'MSR',
  'Anguilla': 'AIA',
  'British Virgin Islands': 'VGB',
  'Cayman Islands': 'CYM',
  'Turks and Caicos Islands': 'TCA',
  'Sint Maarten': 'SXM',
  'American Samoa': 'ASM',
  'Cook Islands': 'COK',
  'Niue': 'NIU',
  'Tokelau': 'TKL',
  'US Virgin Islands': 'VIR',
  'Micronesia': 'FSM',
  'Northern Mariana Islands': 'MNP',
  'Pitcairn Islands': 'PCN',
  'Wallis and Futuna': 'WLF',
  'Saint Helena': 'SHN',
  'Falkland Islands': 'FLK',
  'Macau': 'MAC',
  'Bonaire': 'BES',
  'Saint Barthélemy': 'BLM',
  'Saint Martin': 'MAF',
  'Netherlands Antilles': 'ANT',
};

// Build a case-insensitive lookup and common alias map
const ALIASES = {
  'dr congo': 'COD',
  'drc': 'COD',
  'congo dr': 'COD',
  'congo, democratic republic': 'COD',
  'congo, dem. rep.': 'COD',
  'dem. rep. congo': 'COD',
  'ivory coast': 'CIV',
  'cote divoire': 'CIV',
  'burma': 'MMR',
  'republic of korea': 'KOR',
  'south korea': 'KOR',
  'north korea': 'PRK',
  'palestine': 'PSE',
  'palestinian territory': 'PSE',
  'west bank and gaza': 'PSE',
  'cabo verde': 'CPV',
  'cape verde': 'CPV',
  'czech republic': 'CZE',
  'czechia': 'CZE',
  'korea': 'KOR',
  'lao': 'LAO',
  'tanzania': 'TZA',
  'vietnam': 'VNM',
  'micronesia': 'FSM',
  // UN-formal and variant names found in CGIAR data
  'tanzania, united republic': 'TZA',
  'united republic of tanzania': 'TZA',
  'the socialist republic of viet nam': 'VNM',
  'bolivia (plurinational state of)': 'BOL',
  'iran (islamic republic of)': 'IRN',
  'the democratic republic of the congo': 'COD',
  'the republic of korea': 'KOR',
  "the democratic people's republic of korea": 'PRK',
  'the republic of the sudan': 'SDN',
  'netherlands (kingdom of the)': 'NLD',
  'united kingdom of great britain and northern ireland': 'GBR',
  'united states of america': 'USA',
  'venezuela (bolivarian republic of)': 'VEN',
  'republic of moldova': 'MDA',
  'state of palestine': 'PSE',
  'taiwan (province of china)': 'TWN',
  'the united arab emirates': 'ARE',
  'türkiye': 'TUR',
  'turkey': 'TUR',
  'turkiye': 'TUR',
};

/**
 * ISO 3166-1 numeric → alpha-3 mapping.
 * world-atlas@2 TopoJSON uses numeric IDs (e.g. "404" for Kenya).
 * This table converts them to alpha-3 codes that match our getISO3() output.
 */
const NUMERIC_TO_ALPHA3 = {
  '4': 'AFG', '8': 'ALB', '12': 'DZA', '20': 'AND', '24': 'AGO',
  '28': 'ATG', '32': 'ARG', '51': 'ARM', '36': 'AUS', '40': 'AUT',
  '31': 'AZE', '44': 'BHS', '48': 'BHR', '50': 'BGD', '52': 'BRB',
  '112': 'BLR', '56': 'BEL', '84': 'BLZ', '204': 'BEN', '64': 'BTN',
  '68': 'BOL', '70': 'BIH', '72': 'BWA', '76': 'BRA', '96': 'BRN',
  '100': 'BGR', '854': 'BFA', '108': 'BDI', '132': 'CPV', '116': 'KHM',
  '120': 'CMR', '124': 'CAN', '140': 'CAF', '148': 'TCD', '152': 'CHL',
  '156': 'CHN', '170': 'COL', '174': 'COM', '178': 'COG', '180': 'COD',
  '188': 'CRI', '384': 'CIV', '191': 'HRV', '192': 'CUB', '196': 'CYP',
  '203': 'CZE', '208': 'DNK', '262': 'DJI', '212': 'DMA', '214': 'DOM',
  '218': 'ECU', '818': 'EGY', '222': 'SLV', '226': 'GNQ', '232': 'ERI',
  '233': 'EST', '231': 'ETH', '748': 'SWZ', '242': 'FJI', '246': 'FIN',
  '250': 'FRA', '266': 'GAB', '270': 'GMB', '268': 'GEO', '276': 'DEU',
  '288': 'GHA', '300': 'GRC', '308': 'GRD', '320': 'GTM', '324': 'GIN',
  '624': 'GNB', '328': 'GUY', '332': 'HTI', '340': 'HND', '348': 'HUN',
  '352': 'ISL', '356': 'IND', '360': 'IDN', '364': 'IRN', '368': 'IRQ',
  '372': 'IRL', '376': 'ISR', '380': 'ITA', '388': 'JAM', '392': 'JPN',
  '400': 'JOR', '398': 'KAZ', '404': 'KEN', '296': 'KIR', '408': 'PRK',
  '410': 'KOR', '414': 'KWT', '417': 'KGZ', '418': 'LAO', '428': 'LVA',
  '422': 'LBN', '426': 'LSO', '430': 'LBR', '434': 'LBY', '440': 'LTU',
  '442': 'LUX', '450': 'MDG', '454': 'MWI', '458': 'MYS', '462': 'MDV',
  '466': 'MLI', '470': 'MLT', '478': 'MRT', '480': 'MUS', '484': 'MEX',
  '498': 'MDA', '496': 'MNG', '499': 'MNE', '504': 'MAR', '508': 'MOZ',
  '104': 'MMR', '516': 'NAM', '524': 'NPL', '528': 'NLD', '554': 'NZL',
  '558': 'NIC', '562': 'NER', '566': 'NGA', '807': 'MKD', '578': 'NOR',
  '512': 'OMN', '586': 'PAK', '591': 'PAN', '598': 'PNG', '600': 'PRY',
  '604': 'PER', '608': 'PHL', '616': 'POL', '620': 'PRT', '634': 'QAT',
  '642': 'ROU', '643': 'RUS', '646': 'RWA', '662': 'LCA', '670': 'VCT',
  '882': 'WSM', '678': 'STP', '682': 'SAU', '686': 'SEN', '688': 'SRB',
  '690': 'SYC', '694': 'SLE', '702': 'SGP', '703': 'SVK', '705': 'SVN',
  '90': 'SLB', '706': 'SOM', '710': 'ZAF', '728': 'SSD', '724': 'ESP',
  '144': 'LKA', '729': 'SDN', '740': 'SUR', '752': 'SWE', '756': 'CHE',
  '760': 'SYR', '158': 'TWN', '762': 'TJK', '834': 'TZA', '764': 'THA',
  '626': 'TLS', '768': 'TGO', '776': 'TON', '780': 'TTO', '788': 'TUN',
  '792': 'TUR', '795': 'TKM', '800': 'UGA', '804': 'UKR', '784': 'ARE',
  '826': 'GBR', '840': 'USA', '858': 'URY', '860': 'UZB', '548': 'VUT',
  '862': 'VEN', '704': 'VNM', '887': 'YEM', '894': 'ZMB', '716': 'ZWE',
  // Territories / special
  '275': 'PSE', '732': 'ESH', '-99': 'CYN', '10': 'ATA',
};

/**
 * Convert a world-atlas numeric ID to ISO alpha-3.
 * @param {string} numericId - e.g. "404"
 * @returns {string|null} alpha-3 code or null
 */
export function numericToAlpha3(numericId) {
  // world-atlas@2 uses zero-padded 3-digit IDs (e.g. "076" for Brazil)
  // but our lookup table uses unpadded keys (e.g. "76").
  // Try the raw ID first, then strip leading zeros.
  return NUMERIC_TO_ALPHA3[numericId]
    || NUMERIC_TO_ALPHA3[String(Number(numericId))]
    || null;
}

// Build normalized lookup from main map
const normalizedMap = new Map();
for (const [name, code] of Object.entries(COUNTRY_TO_ISO3)) {
  normalizedMap.set(name.toLowerCase().trim(), code);
}
for (const [alias, code] of Object.entries(ALIASES)) {
  normalizedMap.set(alias.toLowerCase().trim(), code);
}

/**
 * Get ISO 3166-1 alpha-3 code for a country name.
 * Performs case-insensitive matching and handles common variations.
 * @param {string} countryName - The country name to look up
 * @returns {string|null} ISO3 code or null if not found
 */
export function getISO3(countryName) {
  if (!countryName) return null;

  const normalized = countryName.toLowerCase().trim();

  // Direct lookup
  if (normalizedMap.has(normalized)) {
    return normalizedMap.get(normalized);
  }

  // Try removing diacritics and special chars
  const simplified = normalized
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['']/g, "'");
  if (normalizedMap.has(simplified)) {
    return normalizedMap.get(simplified);
  }

  // Try partial match (for cases like "Congo, Democratic Republic of the")
  for (const [key, code] of normalizedMap.entries()) {
    if (normalized.includes(key) || key.includes(normalized)) {
      return code;
    }
  }

  return null;
}

/**
 * UN "Developing economies" classification (UNCTAD).
 * Source: DimCountries_All_Hierarchy.xls — all countries under code 1400.
 */
const GLOBAL_SOUTH_ISO3 = new Set([
  // Africa
  'AGO','BDI','BEN','BFA','BWA','CAF','CIV','CMR','COD','COG','COM','CPV','DJI',
  'DZA','EGY','ERI','ESH','ETH','GAB','GHA','GIN','GMB','GNB','GNQ','KEN','LBR',
  'LBY','LSO','MAR','MDG','MLI','MOZ','MRT','MUS','MWI','MYT','NAM','NER','NGA',
  'REU','RWA','SDN','SEN','SHN','SLE','SOM','SSD','STP','SWZ','SYC','TCD','TGO',
  'TUN','TZA','UGA','ZAF','ZMB','ZWE',
  // Latin America & Caribbean
  'ABW','AIA','ANT','ARG','BES','BLM','BLZ','BOL','BRA','CHL','COL','CRI','CUB',
  'CUW','CYM','DMA','DOM','ECU','GLP','GRD','GTM','GUF','GUY','HND','HTI','JAM',
  'KNA','LCA','MAF','MEX','MSR','MTQ','NIC','PAN','PER','PRI','PRY','SLV','SUR',
  'SXM','TCA','TTO','URY','VCT','VEN','VGB','VIR',
  // South Asia
  'AFG','BGD','BTN','IND','IRN','LKA','MDV','NPL','PAK',
  // Southeast Asia
  'BRN','IDN','KHM','LAO','MMR','MYS','PHL','SGP','THA','TLS','VNM',
  // East Asia
  'CHN','HKG','MAC','MNG','PRK','TWN',
  // Central Asia
  'KAZ','KGZ','TJK','TKM','UZB',
  // Western Asia & Middle East
  'ARE','ARM','AZE','BHR','GEO','IRQ','JOR','KWT','LBN','OMN','PSE','QAT','SAU',
  'SYR','TUR','YEM',
  // Pacific
  'ASM','COK','FJI','FSM','GUM','KIR','MHL','MNP','NCL','NIU','NRU','PLW','PNG',
  'PYF','SLB','TKL','TON','TUV','VUT','WLF','WSM',
  // Other territories
  'ATF','ATG','BHS','BRB','BVT','FLK','IOT','PCN','SGS',
]);

/**
 * ISO3 → UN M49 sub-region string.
 * Sub-region names match those used in CGIAR results data and REGIONS[].match
 * in RegionalFocusSection.jsx.
 */
const ISO3_TO_SUBREGION = {
  // Western Africa
  'BEN': 'Western Africa', 'BFA': 'Western Africa', 'CPV': 'Western Africa',
  'CIV': 'Western Africa', 'GMB': 'Western Africa', 'GHA': 'Western Africa',
  'GIN': 'Western Africa', 'GNB': 'Western Africa', 'LBR': 'Western Africa',
  'MLI': 'Western Africa', 'MRT': 'Western Africa', 'NER': 'Western Africa',
  'NGA': 'Western Africa', 'SEN': 'Western Africa', 'SLE': 'Western Africa',
  'TGO': 'Western Africa', 'SHN': 'Western Africa',
  // Eastern Africa
  'BDI': 'Eastern Africa', 'COM': 'Eastern Africa', 'DJI': 'Eastern Africa',
  'ERI': 'Eastern Africa', 'ETH': 'Eastern Africa', 'KEN': 'Eastern Africa',
  'MDG': 'Eastern Africa', 'MWI': 'Eastern Africa', 'MUS': 'Eastern Africa',
  'MYT': 'Eastern Africa', 'MOZ': 'Eastern Africa', 'REU': 'Eastern Africa',
  'RWA': 'Eastern Africa', 'SYC': 'Eastern Africa', 'SOM': 'Eastern Africa',
  'SSD': 'Eastern Africa', 'TZA': 'Eastern Africa', 'UGA': 'Eastern Africa',
  'ZMB': 'Eastern Africa', 'ZWE': 'Eastern Africa',
  // Middle Africa
  'AGO': 'Middle Africa', 'CMR': 'Middle Africa', 'CAF': 'Middle Africa',
  'TCD': 'Middle Africa', 'COG': 'Middle Africa', 'COD': 'Middle Africa',
  'GNQ': 'Middle Africa', 'GAB': 'Middle Africa', 'STP': 'Middle Africa',
  // Northern Africa
  'DZA': 'Northern Africa', 'EGY': 'Northern Africa', 'LBY': 'Northern Africa',
  'MAR': 'Northern Africa', 'SDN': 'Northern Africa', 'TUN': 'Northern Africa',
  'ESH': 'Northern Africa',
  // Southern Africa
  'BWA': 'Southern Africa', 'SWZ': 'Southern Africa', 'LSO': 'Southern Africa',
  'NAM': 'Southern Africa', 'ZAF': 'Southern Africa',
  // Caribbean
  'ATG': 'Caribbean', 'BHS': 'Caribbean', 'BRB': 'Caribbean', 'CUB': 'Caribbean',
  'DMA': 'Caribbean', 'DOM': 'Caribbean', 'GRD': 'Caribbean', 'HTI': 'Caribbean',
  'JAM': 'Caribbean', 'KNA': 'Caribbean', 'LCA': 'Caribbean', 'VCT': 'Caribbean',
  'TTO': 'Caribbean', 'ABW': 'Caribbean', 'CUW': 'Caribbean', 'CYM': 'Caribbean',
  'PRI': 'Caribbean', 'VGB': 'Caribbean', 'VIR': 'Caribbean', 'AIA': 'Caribbean',
  'MSR': 'Caribbean', 'TCA': 'Caribbean', 'SXM': 'Caribbean', 'BES': 'Caribbean',
  'BLM': 'Caribbean', 'MAF': 'Caribbean', 'GLP': 'Caribbean', 'MTQ': 'Caribbean',
  'ANT': 'Caribbean',
  // Central America
  'BLZ': 'Central America', 'CRI': 'Central America', 'SLV': 'Central America',
  'GTM': 'Central America', 'HND': 'Central America', 'MEX': 'Central America',
  'NIC': 'Central America', 'PAN': 'Central America',
  // South America
  'ARG': 'South America', 'BOL': 'South America', 'BRA': 'South America',
  'CHL': 'South America', 'COL': 'South America', 'ECU': 'South America',
  'GUF': 'South America', 'GUY': 'South America', 'PRY': 'South America',
  'PER': 'South America', 'SUR': 'South America', 'URY': 'South America',
  'VEN': 'South America', 'FLK': 'South America',
  // Northern America
  'CAN': 'Northern America', 'USA': 'Northern America',
  // Southern Asia
  'AFG': 'Southern Asia', 'BGD': 'Southern Asia', 'BTN': 'Southern Asia',
  'IND': 'Southern Asia', 'IRN': 'Southern Asia', 'MDV': 'Southern Asia',
  'NPL': 'Southern Asia', 'PAK': 'Southern Asia', 'LKA': 'Southern Asia',
  // South-Eastern Asia
  'BRN': 'South-Eastern Asia', 'KHM': 'South-Eastern Asia', 'IDN': 'South-Eastern Asia',
  'LAO': 'South-Eastern Asia', 'MYS': 'South-Eastern Asia', 'MMR': 'South-Eastern Asia',
  'PHL': 'South-Eastern Asia', 'SGP': 'South-Eastern Asia', 'THA': 'South-Eastern Asia',
  'TLS': 'South-Eastern Asia', 'VNM': 'South-Eastern Asia',
  // Eastern Asia
  'CHN': 'Eastern Asia', 'HKG': 'Eastern Asia', 'MAC': 'Eastern Asia',
  'MNG': 'Eastern Asia', 'PRK': 'Eastern Asia', 'KOR': 'Eastern Asia',
  'TWN': 'Eastern Asia', 'JPN': 'Eastern Asia',
  // Central Asia
  'KAZ': 'Central Asia', 'KGZ': 'Central Asia', 'TJK': 'Central Asia',
  'TKM': 'Central Asia', 'UZB': 'Central Asia',
  // Western Asia
  'ARM': 'Western Asia', 'AZE': 'Western Asia', 'BHR': 'Western Asia',
  'GEO': 'Western Asia', 'IRQ': 'Western Asia', 'ISR': 'Western Asia',
  'JOR': 'Western Asia', 'KWT': 'Western Asia', 'LBN': 'Western Asia',
  'OMN': 'Western Asia', 'PSE': 'Western Asia', 'QAT': 'Western Asia',
  'SAU': 'Western Asia', 'SYR': 'Western Asia', 'TUR': 'Western Asia',
  'ARE': 'Western Asia', 'YEM': 'Western Asia', 'CYP': 'Western Asia',
  // Western Europe
  'DEU': 'Western Europe', 'FRA': 'Western Europe', 'AUT': 'Western Europe',
  'BEL': 'Western Europe', 'CHE': 'Western Europe', 'NLD': 'Western Europe',
  'LUX': 'Western Europe',
  // Northern Europe
  'GBR': 'Northern Europe', 'IRL': 'Northern Europe', 'DNK': 'Northern Europe',
  'FIN': 'Northern Europe', 'SWE': 'Northern Europe', 'NOR': 'Northern Europe',
  'EST': 'Northern Europe', 'LVA': 'Northern Europe', 'LTU': 'Northern Europe',
  'ISL': 'Northern Europe',
  // Southern Europe
  'ESP': 'Southern Europe', 'ITA': 'Southern Europe', 'PRT': 'Southern Europe',
  'GRC': 'Southern Europe', 'MLT': 'Southern Europe', 'HRV': 'Southern Europe',
  'SVN': 'Southern Europe', 'BIH': 'Southern Europe', 'MNE': 'Southern Europe',
  'MKD': 'Southern Europe', 'SRB': 'Southern Europe', 'ALB': 'Southern Europe',
  'AND': 'Southern Europe',
  // Eastern Europe
  'POL': 'Eastern Europe', 'ROU': 'Eastern Europe', 'BGR': 'Eastern Europe',
  'HUN': 'Eastern Europe', 'CZE': 'Eastern Europe', 'SVK': 'Eastern Europe',
  'UKR': 'Eastern Europe', 'RUS': 'Eastern Europe', 'BLR': 'Eastern Europe',
  'MDA': 'Eastern Europe',
  // Australia and New Zealand
  'AUS': 'Australia and New Zealand', 'NZL': 'Australia and New Zealand',
  // Melanesia
  'FJI': 'Melanesia', 'PNG': 'Melanesia', 'SLB': 'Melanesia',
  'VUT': 'Melanesia', 'NCL': 'Melanesia',
  // Micronesia
  'FSM': 'Micronesia', 'GUM': 'Micronesia', 'KIR': 'Micronesia',
  'MHL': 'Micronesia', 'MNP': 'Micronesia', 'NRU': 'Micronesia', 'PLW': 'Micronesia',
  // Polynesia
  'WSM': 'Polynesia', 'TON': 'Polynesia', 'TUV': 'Polynesia', 'COK': 'Polynesia',
  'NIU': 'Polynesia', 'TKL': 'Polynesia', 'PYF': 'Polynesia', 'WLF': 'Polynesia',
  'ASM': 'Polynesia', 'PCN': 'Polynesia',
};

/**
 * Get the UN M49 sub-region for an ISO3 country code.
 */
export function getSubRegion(iso3) {
  return iso3 ? (ISO3_TO_SUBREGION[iso3] || null) : null;
}

/**
 * Check whether a country name belongs to any of the given sub-regions.
 */
export function isCountryInSubRegions(countryName, subRegionSet) {
  const iso3 = getISO3(countryName);
  if (!iso3) return false;
  const subRegion = ISO3_TO_SUBREGION[iso3];
  return subRegion ? subRegionSet.has(subRegion) : false;
}

/**
 * Composite sub-region strings → component sub-regions they encompass.
 */
const COMPOSITE_SUBREGIONS = {
  'Sub-Saharan Africa': ['Western Africa', 'Eastern Africa', 'Middle Africa', 'Southern Africa'],
  'Latin America and the Caribbean': ['South America', 'Central America', 'Caribbean'],
};

/**
 * Expand a match list so composite sub-regions are replaced by their components.
 * Returns a Set of concrete sub-region strings.
 */
export function expandSubRegions(matchList) {
  const expanded = new Set();
  matchList.forEach(m => {
    const components = COMPOSITE_SUBREGIONS[m];
    if (components) {
      components.forEach(c => expanded.add(c));
    } else {
      expanded.add(m);
    }
  });
  return expanded;
}

/**
 * Derive sub-region strings from a countries field (string or array).
 * Used as a fallback when result.regions is missing but result.countries exists.
 * Returns a Set of sub-region strings (e.g. {"Western Africa", "South America"}).
 */
export function deriveSubRegionsFromCountries(countries) {
  if (!countries) return new Set();
  const list = Array.isArray(countries)
    ? countries
    : String(countries).split(/\r?\n/)
        .flatMap(line => line.split(';'))
        .map(s => s.replace(/^[-\s]+/, '').trim())
        .filter(Boolean);
  const subRegions = new Set();
  for (const country of list) {
    const iso3 = getISO3(country);
    if (iso3) {
      const sr = ISO3_TO_SUBREGION[iso3];
      if (sr) subRegions.add(sr);
    }
  }
  return subRegions;
}

// Build a lowercase country-name → boolean lookup for fast filtering
const globalSouthNameSet = new Set();
for (const [name, iso3] of Object.entries(COUNTRY_TO_ISO3)) {
  if (GLOBAL_SOUTH_ISO3.has(iso3)) {
    globalSouthNameSet.add(name.toLowerCase().trim());
  }
}
for (const [alias, iso3] of Object.entries(ALIASES)) {
  if (GLOBAL_SOUTH_ISO3.has(iso3)) {
    globalSouthNameSet.add(alias.toLowerCase().trim());
  }
}

/**
 * Check if a raw countries string (as stored in result.countries) contains
 * at least one Global South country. Works with the `\r\n-` delimited format.
 */
export function hasGlobalSouthCountry(countriesLower) {
  if (!countriesLower) return false;
  for (const name of globalSouthNameSet) {
    if (countriesLower.includes(name)) return true;
  }
  return false;
}

/**
 * Check if an ISO3 code belongs to the Global South.
 */
export function isGlobalSouthISO3(iso3) {
  return iso3 ? GLOBAL_SOUTH_ISO3.has(iso3) : false;
}

/**
 * Check if a single country name belongs to the Global South.
 */
export function isGlobalSouthCountry(countryName) {
  if (!countryName) return false;
  return globalSouthNameSet.has(countryName.toLowerCase().trim());
}

/**
 * Regions that are NOT Global South (used as fallback when country data is missing).
 */
const NON_GLOBAL_SOUTH_REGIONS = new Set([
  'northern america', 'northern europe', 'southern europe',
  'western europe', 'eastern europe', 'australia and new zealand',
]);

/**
 * Check if a raw regions string contains at least one Global South region.
 * Any region not in the exclusion set is considered Global South.
 */
export function hasGlobalSouthRegion(regionsLower) {
  if (!regionsLower) return false;
  const parts = regionsLower.split('\n').map(p => p.replace(/^-/, '').trim()).filter(Boolean);
  return parts.some(r => r !== 'not applicable' && !NON_GLOBAL_SOUTH_REGIONS.has(r));
}

export default COUNTRY_TO_ISO3;
